// extracted by mini-css-extract-plugin
export default {"msg_container":"Gba","message":"Hba","show":"Iba","fromRD":"Jba","fromCustomer":"Kba","note":"Lba","loading":"Mba","image":"Nba","initials":"Oba","input_wrapper":"Pba","input":"Qba"};
    if(module.hot) {
      // 1714442371905
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  